import React, { ReactNode } from 'react';
import CarIcon from './shared/CarIcon';
import { currentTenant } from '../tenant/tenants';

const { supportEmail } = currentTenant.brand;

interface EmptyStateProps {
    message?: ReactNode;
    animate?: boolean;
}

const EmptyState: React.FC<EmptyStateProps> = ({
    message = (
        <>
            Lap times will appear after you complete a few laps. If they don’t, contact us at{' '}
            <a href={`mailto:${supportEmail}`} className="text-white text-decoration-underline">
                {supportEmail}
            </a>{' '}
            with your details.
        </>
    ),
    animate = false
}) => {
    return (
        <div className="text-center py-4">
            <p className="text-paragraphs mb-0">{message}</p>
            <div className="mt-3 text-paragraphs opacity-50">
                <CarIcon animate={animate} />
            </div>
        </div>
    );
};

export default EmptyState;
